import { PostalAddressDto } from "Store/interfaces/PostalAddressDto";
import { ReduxState } from "Store/rootReducer";
import { isDefined } from "Utils/functions";
import { useSelector } from "react-redux";
import { UserIdentificationData } from ".";

export const userIdentificationSelector = (
  state: ReduxState,
): UserIdentificationData | null => state.userIdentification.current;

export const customerNinSelector = (state: ReduxState): string | undefined =>
  state.userIdentification.current?.nin;

export const customerDateOfBirthSelector = (
  state: ReduxState,
): string | undefined =>
  state.userIdentification.current?.newCustomerResponse.dateOfBirth;

export const customerRefSelector = (state: ReduxState): string | undefined =>
  state.userIdentification.current?.newCustomerResponse.customerRef;

export const customerIsValidSelector = (
  state: ReduxState,
): boolean | undefined =>
  state.userIdentification.current?.newCustomerResponse.isValid;

export const customerAddressSelector = (
  state: ReduxState,
): PostalAddressDto | undefined =>
  state.userIdentification.current?.newCustomerResponse.providedContactInfo
    ?.address;

export const useUserIdentificationSelector =
  (): UserIdentificationData | null => useSelector(userIdentificationSelector);

export const useCustomerRefSelector = (): string | undefined =>
  useSelector(customerRefSelector);

export const useCustomerAddressSelector = (): PostalAddressDto | undefined =>
  useSelector(customerAddressSelector);

export const useIsCustomerNameNinIdentificationValid = (): boolean => {
  const custmerIsValid = useSelector(customerIsValidSelector);
  return isDefined(custmerIsValid) && custmerIsValid;
};
